import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import ManagedFormGroup from 'components/form/managed_input/form_group';

export function TransactionSideInput({ transactionSideOptions, transactionSide, onChange }) {
  if (!transactionSideOptions) return null;

  return (
    <ManagedFormGroup
      includeBlank
      label="Transaction Side"
      required
      type="select"
      value={transactionSide}
      onValueChange={onChange}
    >
      {transactionSideOptions.map(([value, label]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </ManagedFormGroup>
  );
}

TransactionSideInput.propTypes = {
  transactionSide: PropTypes.string,
  transactionSideOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  })).isRequired,
  onChange: PropTypes.func,
};

const mapStateToProps = state => ({
  transactionSideOptions: state.options.transactionSide
});

export default connect(mapStateToProps)(TransactionSideInput);

